/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".popup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:10000}.card[_ngcontent-%COMP%]{min-height:400px;width:30%;vertical-align:middle;position:relative;margin:0 auto}.ml-auto[_ngcontent-%COMP%]{margin-left:auto}.right[_ngcontent-%COMP%]{float:right}\n/*# sourceMappingURL=assignment-details.component.css.map*/"];
export { styles as styles };
